module.exports = __webpack_public_path__ + "assets/img/3.594ff368.png";